import {Fragment, Suspense} from "react";
import { FRAGMENTS, type FragmentsKey } from "./fragmentRegistry.ts";

type Props = { id: FragmentsKey;  props?: Record<string, unknown> };

export function RenderFragment({ id, props }: Props) {
  const Cmp = FRAGMENTS[id];
  return (
    <Fragment key={id}>
      <Suspense fallback={null}>
        {/* @ts-expect-error: props dinámicas por JSON */}
        <Cmp {...props}/>
      </Suspense>
    </Fragment>
);
}
